import { Typography } from "@shared/ui.primitives";
import type { ReactElement } from "react";
import React from "react";

import { profileHeaderStyle, subheaderWrapper } from "./ProfileHeader.css";

export const ProfileHeader = ({
  title,
  subheader
}: {
  title: string;
  subheader?: string;
}): ReactElement => {
  return (
    <>
      <div className={profileHeaderStyle}>
        {title && <Typography variant="header-1">{title}</Typography>}
        <div className={subheaderWrapper}>
          {subheader && <Typography variant="body-md">{subheader}</Typography>}
        </div>
      </div>
    </>
  );
};
